import { ROTATIONSPLAN_VORLAGE_BY_ID } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanVorlageById/graphql/queries';
import {
  Mitarbeiter_RotationsplanVorlageByIdQuery,
  Mitarbeiter_RotationsplanVorlageByIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

export type RotationsplanVorlageDetails = NonNullable<
  Mitarbeiter_RotationsplanVorlageByIdQuery['mitarbeiter_rotationsplanVorlageById']
>;

export type VorlageAbschnittDetails =
  RotationsplanVorlageDetails['abschnitte'][number];

export type VorlageStationDetails =
  VorlageAbschnittDetails['stationen'][number];

export function useRotationsplanVorlageById(rotationsplanVorlageId: string): {
  vorlage?: RotationsplanVorlageDetails;
} {
  const result = useSuspenseQuery<
    Mitarbeiter_RotationsplanVorlageByIdQuery,
    Mitarbeiter_RotationsplanVorlageByIdQueryVariables
  >(ROTATIONSPLAN_VORLAGE_BY_ID, {
    variables: { rotationsplanVorlageId },
  });

  if (result.error) {
    Sentry.captureException(result.error);
    return { vorlage: undefined };
  }

  return {
    vorlage: result.data?.mitarbeiter_rotationsplanVorlageById ?? undefined,
  };
}
